import { Select, SelectChangeEvent } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Paper } from "@mui/material";
import React, { Suspense, useEffect } from "react";
import { useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { CustomInput, CustomSelectInput } from "../../../shared/CustomInput";
import ThemeFormSubHeader from "../../../shared/themeFormSubHeader/ThemeFormSubHeader";
import { Tooltip, Chip, Button, Grid } from "@mui/material";
import downloadFile from "../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../utils/commonFunctions/shortenFileName";
import validateEmail from "../../../../utils/commonFunctions/validateEmail";
import { useQuery } from "../../../../hooks";

import STATES from "../../../../constants/states";
import RELATIONSHIPS from "../../../../constants/relationships";
import EVENT_NAMES from "../../../../constants/eventNames";
import GENDERS from "../../../../constants/genders";
import DEPENDENT_TYPES from "../../../../constants/dependentTypes";
import CONTACT_LABELS from "../../../../constants/contactLabels";

import PublishIcon from "@mui/icons-material/Publish";

import "./addDependent.css";
import { useLocation } from "react-router-dom";

const buttonCaption = "Upload File";
/* eslint-disable */
const AddDependent = () => {
	const [dependentForm, setDependentForm] = useState({});
	const [isValidEmployeeId, setIsValidEmployeeId] = useState(null);
	const [hasSpouse, setHasSpouse] = useState(true); // This value will feed from getEmployee api
	const [isEnrollment, setIsEnrollment] = useState(true); // will feed the value when enrollment will be done
	const [emailExists, setEmailExists] = useState(false);
	const [checkInvalidEmail, setCheckInvalidEmail] = useState(false);
	const [pasted, setPasted] = useState(false);
	const [hasCreateClick, setHasCreateClick] = useState(false);
	const location = useLocation();
	const query = useQuery();
	const [isView, setIsView] = useState(true);
	const [availableEventNames, setAvailableEventNames] = useState([]);
	const [dependent, setDependent] = useState({
		employee_number: null,
		first_name: "",
		middle_name: "",
		last_name: "",
		email: "",
		SSN: null,
		date_of_birth: "",
		dependent_type: "",
		gender: "",
		relationship: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States of America",
		ZIP: "",
		contact_label: "",
		event_date: "",
		event_name: "",
		event_document: null
	});

	const [validation, setValidation] = useState({
		dependent: {}
	});
	let _validation = useRef();
	let history = useHistory();

	const handleKeyCheck = useCallback(
		(event) => {
			var { name, value } = event.target;
			var keyID = event.keyCode;

			if (name === "ZIP") {
				if (keyID === 8 || keyID === 46) {
					if (/[-]/.test(value) && value.length === 7) {
						var index = value.indexOf("-");
						value = value.substr(0, index + 1);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
				}
			}
			if (name === "SSN") {
				if (keyID === 8 || keyID === 46) {
					if (/[-]/.test(value) && value.length === 4) {
						var index = value.indexOf("-");
						value = value.substr(0, index);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
					if (/[-]/.test(value) && value.length === 7) {
						var index = value.lastIndexOf("-");
						value = value.substr(0, index);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
				}
			}
		},
		[dependent]
	);

	const handlePaste = (event) => {
		let { name } = event.target;
		if (name === "SSN" || name === "ZIP") {
			setPasted(true);
			setTimeout(2000);
		}
	};

	const handleDependentChange = useCallback(
		(event) => {
			let { name, value } = event.target;

			if (name === "first_name") {
				var regex = /^[a-zA-Z]+$/;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setDependent(Object.assign({}, dependent, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setDependent(Object.assign({}, dependent, { [name]: value }));
				}
			} else if (name === "relationship") {
				if (
					dependent.event_name === "Birth of Baby" &&
					(value === "Stepchild" ||
						value === "Disabled Child" ||
						value === "Legal Custody Child" ||
						value === "Court-Ordered Dependent")
				)
					dependent.event_name = "";
				else if (
					(dependent.event_name === "Adoption or Placement for Adoption of a Child" ||
						dependent.event_name === "Others") &&
					(value === "Son" || value === "Daughter" || value === "Grandchild")
				)
					dependent.event_name = "";
				else if (
					dependent.event_name === "Marriage" &&
					(value === "Son" ||
						value === "Daughter" ||
						value === "Grandchild" ||
						value === "Stepchild" ||
						value === "Disabled Child" ||
						value === "Legal Custody Child" ||
						value === "Court-Ordered Dependent")
				)
					dependent.event_name = "";
				else if (
					(dependent.event_name === "Adoption or Placement for Adoption of a Child" ||
						dependent.event_name === "Others" ||
						dependent.event_name === "Birth of Baby") &&
					value === "Spouse"
				)
					dependent.event_name = "";

				setDependent(Object.assign({}, dependent, { [name]: value }));
			} else if (name === "email") {
				//findMemberEmail(value);

				setDependent(Object.assign({}, dependent, { [name]: value }));
			} else if (name === "SSN") {
				if (!pasted) {
					// console.log("Not Pasted");
					var _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value)) {
						let ssn = value;
						if (
							!(
								/^[0-9]{0,3}$/.test(value) ||
								/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
								/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
							)
						) {
							value = value.substr(0, value.length - 1);
						} else if (ssn.length === 6) {
							value = value.substr(0, 7) + "-" + value.substr(7);
						} else if (ssn.length === 3) {
							value = value.substr(0, 3) + "-" + value.substr(3);
						}

						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = null;
						event.target.value = dependent.SSN;
					}
				} else {
					// console.log("Pasted");
					setPasted(false);
					if (!isNaN(value)) {
						if (value.length > 9) {
							event.target.value = null;
							event.target.value = dependent.SSN;
							alert("Please enter a valid 9 digit SSN!");
						} else {
							// console.log("Inside Number");
							let ssn = value;

							if (ssn.length === 4) {
								value = value.substr(0, 3) + "-" + value.substr(3);
							} else if (ssn.length === 5) {
								value = value.substr(0, 3) + "-" + value.substr(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								value = value.substr(0, 3) + "-" + value.substr(3, 2) + "-" + value.substr(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						var ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", ssnValue);
						alert("You have pasted alpha-numeric SSN!");

						if (ssnValue.length > 9) {
							event.target.value = null;
							event.target.value = dependent.SSN;
							alert("Please enter a valid SSN!");
						} else {
							let ssn = ssnValue;

							if (ssn.length === 4) {
								ssnValue = ssnValue.substr(0, 3) + "-" + ssnValue.substr(3);
							} else if (ssn.length === 5) {
								ssnValue = ssnValue.substr(0, 3) + "-" + ssnValue.substr(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								ssnValue =
									ssnValue.substr(0, 3) + "-" + ssnValue.substr(3, 2) + "-" + ssnValue.substr(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: ssnValue }));
						}
					}
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					var _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value) && value.length <= 10) {
						let zip = value;
						if (zip.length === 6) {
							value = value.substr(0, 5) + "-" + value.substr(5);
						}

						console.log("ZIP Event", event.target.value);
						setDependent(
							Object.assign({}, dependent, {
								[name]: value
							})
						);
					} else {
						event.target.value = null;
						event.target.value = dependent.ZIP;
					}
				} else {
					setPasted(false);
					if (!isNaN(value)) {
						if (value.length > 9) {
							event.target.value = null;
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							let zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substr(0, 5) + "-" + value.substr(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						var zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = null;
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							let zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substr(0, 5) + "-" + zipValue.substr(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: zipValue }));
						}
					}
				}
			} else {
				setDependent(Object.assign({}, dependent, { [name]: value }));
			}
		},
		[dependent, pasted]
	);

	const handleDocumentChange = useCallback(
		(event) => {
			const { files } = event.target;
			let _dependent = {
				...dependent,
				event_document: files[0],
				filename: files[0].name
			};
			//setFileInput(fileInput => ({ ...fileInput, [name]: files[0] }))
			setDependent(Object.assign({}, _dependent));
			event.target.value = "";
		},
		[dependent]
	);

	const handleDeleteDocument = useCallback(
		(event) => {
			let _dependent = {
				...dependent,
				event_document: null
			};
			setDependent(Object.assign({}, _dependent));
		},
		[dependent]
	);

	const handleValidation = useCallback(async () => {
		const {
			first_name,
			last_name,
			email,
			SSN,
			date_of_birth,
			dependent_type,
			gender,
			relationship,
			address_line_1,
			city,
			state,
			ZIP,
			contact_label,
			event_date,
			event_name,
			event_document
		} = dependent;
		_validation.current = {
			...validation,
			dependent: {}
		};
		let flag = true;

		if (first_name.length === 0) {
			_validation.current.dependent["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.dependent["last_name"] = "Last name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (SSN === null || SSN === "") {
			_validation.current.dependent["SSN"] = "SSN is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (SSN !== null) {
			if (SSN !== "") {
				var _SSN = SSN.replaceAll("-", "");
				if (String(_SSN).length !== 9) {
					_validation.current.dependent["SSN"] = "Enter correct 9 digit SSN";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		}
		/*if (String(date_of_birth).length === 0) {
			_validation.current.dependent["date_of_birth"] = "Date of birth is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}*/
		if (email.length === 0) {
			_validation.current.dependent["email"] = "Email is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (email.length !== 0) {
			// if (!email.match(mailformat)) {
			// 	_validation.current.dependent["email"] = "Valid Email is required";
			// 	_validation.current["status"] = "invalid";
			// 	flag = false;
			// }
			setCheckInvalidEmail(false);
			if (!validateEmail(email)) {
				setCheckInvalidEmail(true);
			}
		}
		if (gender.length === 0) {
			_validation.current.dependent["gender"] = "Gender is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (relationship.length === 0) {
			_validation.current.dependent["relationship"] = "Relationship is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (dependent_type.length === 0) {
			_validation.current.dependent["dependent_type"] = "Dependent Type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (contact_label.length === 0) {
			_validation.current.dependent["contact_label"] = "Contact Label is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (address_line_1.length === 0) {
			_validation.current.dependent["address_line_1"] = "Address line 1 is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (city.length === 0) {
			_validation.current.dependent["city"] = "City is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (state.length === 0) {
			_validation.current.dependent["state"] = "State is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length === 0) {
			_validation.current.dependent["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length === 0) {
			_validation.current.dependent["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length !== 0) {
			var _zip = ZIP.replaceAll("-", "");
			if (_zip.length === 5) {
				_validation.current["status"] = "valid";
				flag = true;
			} else if (_zip.length === 9) {
				_validation.current["status"] = "valid";
				flag = true;
			} else {
				_validation.current.dependent["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (isEnrollment) {
			/*if (event_date.length === 0) {
				_validation.current.dependent["event_date"] = "Event Date is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}*/
			if (event_name.length === 0) {
				_validation.current.dependent["event_name"] = "Event Name is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			if (event_name !== "") {
				if (event_document === null) {
					_validation.current.dependent["event_document"] = "Event document is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required Family Member details!");
		}

		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [dependent, isEnrollment, validation]);

	const handleDependentDateChange = useCallback(
		(_date, name) => {
			const date = new Date(_date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setDependent(Object.assign({}, dependent, { [name]: parsedDate }));
		},
		[dependent]
	);

	const handleAddDependent = async (event) => {
		await handleValidation();
		if (_validation.status === "valid") {
			event.preventDefault();
			console.log("form is valid");
		}
	};

	// useEffect(() => {
	// 	if (query) {
	// 		const _isValidEmployeeId = query.get("employee_number") ? true : false;
	// 		if (_isValidEmployeeId) {
	// 			const _dependent = {
	// 				...dependent,
	// 				employee_number: Number(query.get("employee_number"))
	// 			};
	// 			console.log(_dependent.employee_number);
	// 			setDependent(Object.assign({}, _dependent));

	// 			setIsValidEmployeeId(true);
	// 		} else {
	// 			setIsValidEmployeeId(false);
	// 			alert("Invalid Employee Number!");
	// 			history.push("/groups/employees");
	// 		}
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [query]);

	useEffect(() => {
		if (location.pathname === "/groups/view-dependent") {
			setIsView(true);
		} else {
			setIsView(false);
		}
	}, [isView, location.pathname]);

	useEffect(() => {
		setAvailableEventNames(
			dependent.relationship === "Spouse"
				? ["Marriage"]
				: dependent.relationship === "Son" ||
				  dependent.relationship === "Daughter" ||
				  dependent.relationship === "Grandchild"
				? ["Birth of Baby"]
				: dependent.relationship === "Stepchild" ||
				  dependent.relationship === "Disabled Child" ||
				  dependent.relationship === "Legal Custody Child" ||
				  dependent.relationship === "Court-Ordered Dependent"
				? ["Adoption or Placement for Adoption of a Child", "Others"]
				: EVENT_NAMES
		);
	}, [dependent]);

	return (
		<div className="add-contacts paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				<Suspense fallback={<div />}>
					{isView ? (
						<ThemeFormSubHeader
							title={"Family Member Details"}
							actionButtons={[]}
							style={{
								marginBottom: "0rem"
							}}
						/>
					) : (
						<ThemeFormSubHeader
							title={"Family Member Details"}
							actionButtons={[
								{
									title: "Add Family Member",
									callback: handleAddDependent
								}
							]}
							style={{
								marginBottom: "0rem"
							}}
						/>
					)}
				</Suspense>
				<div className="details-form-container">
					<div className="details-form-row">
						<div className="details-form-label required">First Name</div>
						<CustomInput
							name="first_name"
							value={dependent.first_name}
							onChange={handleDependentChange}
							// onKeyDown={(event) => handleKeyCheck(event)}
							// onPaste={(event) => handlePaste(event)}
							readOnly={isView ? true : false}
							disabled={true}
						/>
						{validation.dependent["first_name"] ? (
							<div className="error-message">{validation.dependent["first_name"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label">Middle Name</div>
						<CustomInput
							name="middle_name"
							value={dependent.middle_name}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Last Name</div>
						<CustomInput
							name="last_name"
							value={dependent.last_name}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["last_name"] ? (
							<div className="error-message">{validation.dependent["last_name"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">SSN</div>
						<CustomInput
							name="SSN"
							value={dependent.SSN}
							onChange={handleDependentChange}
							onKeyDown={(event) => handleKeyCheck(event)}
							onPaste={(event) => handlePaste(event)}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["SSN"] ? (
							<div className="error-message">{validation.dependent["SSN"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Date Of Birth</div>
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Email</div>
						<CustomInput
							name="email"
							value={dependent.email}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["email"] || checkInvalidEmail || emailExists ? (
							<div className="error-message">
								{emailExists
									? "Email exists!"
									: checkInvalidEmail
									? "Please enter a valid email address!"
									: validation.dependent["email"]}
							</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Dependent Type</div>
						<Select
							value={dependent.dependent_type ? dependent.dependent_type : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="dependent_type"
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{DEPENDENT_TYPES.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
						{validation.dependent["dependent_type"] ? (
							<div className="error-message">{validation.dependent["dependent_type"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Gender</div>
						<Select
							value={dependent.gender ? dependent.gender : ""}
							// input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="gender"
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{GENDERS.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
						{validation.dependent["gender"] ? (
							<div className="error-message">{validation.dependent["gender"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Relationship</div>
						<Select
							value={dependent.relationship ? dependent.relationship : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="relationship"
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{RELATIONSHIPS.map((option) =>
								option === "Spouse" && hasSpouse ? (
									<MenuItem key={option} value={option} disabled>
										{option}
									</MenuItem>
								) : (
									<MenuItem value={option} key={option}>
										{option}
									</MenuItem>
								)
							)}
						</Select>
						{validation.dependent["relationship"] ? (
							<div className="error-message">{validation.dependent["relationship"]}</div>
						) : null}
					</div>
				</div>
				<Suspense fallback={<div />}>
					<ThemeFormSubHeader
						title={"Family Member Address"}
						actionButtons={[]}
						style={{
							marginBottom: "0rem"
						}}
					/>
				</Suspense>
				<div className="details-form-container">
					<div className="details-form-row">
						<div className="details-form-label  required">Address 1</div>
						<CustomInput
							name="address_line_1"
							value={dependent.address_line_1}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["address_line_1"] ? (
							<div className="error-message">{validation.dependent["address_line_1"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label">Address 2</div>
						<CustomInput
							name="address_line_2"
							value={dependent.address_line_2}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">City</div>
						<CustomInput
							name="city"
							value={dependent.city}
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["city"] ? (
							<div className="error-message">{validation.dependent["city"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Zip Code</div>
						<CustomInput
							name="ZIP"
							value={dependent.ZIP}
							onChange={handleDependentChange}
							onKeyDown={(event) => handleKeyCheck(event)}
							onPaste={(event) => handlePaste(event)}
							readOnly={isView ? true : false}
						/>
						{validation.dependent["ZIP"] ? (
							<div className="error-message">{validation.dependent["ZIP"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">State</div>
						<Select
							value={dependent.state ? dependent.state : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="state"
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{STATES.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
						{validation.dependent["state"] ? (
							<div className="error-message">{validation.dependent["state"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Contact Label</div>
						<Select
							value={dependent.contact_label ? dependent.contact_label : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="contact_label"
							onChange={handleDependentChange}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{CONTACT_LABELS.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
						{validation.dependent["contact_label"] ? (
							<div className="error-message">{validation.dependent["contact_label"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Event Name</div>
						<Select
							value={dependent.event_name ? dependent.event_name : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="event_name"
							onChange={(event) => {
								if (dependent.relationship === "") {
									event.target.value = "";
									alert("Please select relationship first!");
									return;
								} else {
									handleDependentChange(event);
								}
							}}
							readOnly={isView ? true : false}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{availableEventNames.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
						{validation.dependent["event_name"] ? (
							<div className="error-message">{validation.dependent["event_name"]}</div>
						) : null}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Event Date</div>{" "}
					</div>
					<div className="details-form-row">
						<div className="details-form-label  required">Dependent Document</div>
						{dependent?.event_document === null ? (
							<>
								<input
									className={"logo-image-upload"}
									id={"logo-image-upload"}
									name="event_document"
									type="file"
									onChange={handleDocumentChange}
									style={{ display: "none" }}
									accept="image/*, .pdf"
								/>
								<label htmlFor={"logo-image-upload"}>
									<Button
										component="span"
										variant="contained"
										style={{
											backgroundColor: "#f5f5f5",
											color: "#20262d",
											width: 190
										}}
									>
										<span className="button-label-with-icon" style={{ color: "#20262d" }}>
											{buttonCaption}
										</span>
										<span>
											<PublishIcon className="button-icon" style={{ color: "#20262d" }} />
										</span>
									</Button>
								</label>
							</>
						) : null}
						<Grid item className="chipset" xl={4} lg={4} md={12} sm={12} xs={12}>
							{dependent?.event_document ? (
								<Tooltip title={"Click to download"} arrow>
									<Chip
										label={
											dependent.event_document
												? shortenFileName(dependent.event_document.name)
												: "No files added"
										}
										onDelete={() => {
											isView ? true : handleDeleteDocument();
										}}
										onClick={() => downloadFile(dependent.event_document)}
									/>
								</Tooltip>
							) : null}
						</Grid>
						{validation.dependent["event_document"] ? (
							<div className="error-message">{validation.dependent["event_document"]}</div>
						) : null}
					</div>
				</div>
				{isView ? null : (
					<Suspense fallback={<div />}>
						<ThemeFormSubHeader
							title={""}
							actionButtons={[
								{
									title: "Add Family Member",
									callback: handleAddDependent
								}
							]}
							style={{
								marginBottom: "0rem"
							}}
						/>
					</Suspense>
				)}
			</Paper>
		</div>
	);
};

export default AddDependent;
